import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const defaultEmailTemplate = buildGetterObject('defaultEmailTemplate');
export const firstPublicEmailTemplate = buildGetterObject('firstPublicEmailTemplate');
export const selectedEmailTemplateId = buildGetterObject('selectedEmailTemplateId');
export const useEmailTemplate = buildGetterObject('useEmailTemplate');
export const useEmailTemplates = buildGetterObject('useEmailTemplates');
export const usePublicEmailTemplate = buildGetterObject('usePublicEmailTemplate');
export const usePublicEmailTemplates = buildGetterObject('usePublicEmailTemplates');
export const useEmailTemplatesArr = buildGetterObject('useEmailTemplates');
export const usePublicEmailTemplatesArr = buildGetterObject('usePublicEmailTemplatesArr');

const getters = {
	[defaultEmailTemplate.getter]: (state, getters) => getters[useEmailTemplatesArr.getter].find((template) => template.is_default_of_acc),
	[firstPublicEmailTemplate.getter]: (state, getters) => getters[usePublicEmailTemplatesArr.getter][0],
	[selectedEmailTemplateId.getter]: (state) => state.selectedEmailTemplateId,
	[useEmailTemplate.getter]: (state) => (templateId) => state.templates[templateId],
	[useEmailTemplates.getter]: (state) => state.templates,
	[usePublicEmailTemplate.getter]: (state) => (templateId) => state.publicEmailTemplates[templateId],
	[usePublicEmailTemplates.getter]: (state) => state.publicEmailTemplates,
	[useEmailTemplatesArr.getter]: (state) => Object.values(state.templates),
	[usePublicEmailTemplatesArr.getter]: (state) => Object.values(state.publicEmailTemplates),
};

export default getters;
